import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Plus, Star } from "lucide-react";
import { toast } from "sonner";

export default function Suppliers() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name:"", category:"", phone:"", email:"", notes:"" });
  const nav = useNavigate();

  const load = useCallback(async () => {
    const { data } = await api.get("/suppliers", { params: q?{q}:{} });
    setRows(data);
  }, [q]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try { await api.post("/suppliers", f); toast.success("Supplier added"); setOpen(false); setF({name:"",category:"",phone:"",email:"",notes:""}); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="suppliers-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500">Contractors &amp; suppliers</div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">Suppliers</h1>
        </div>
        <div className="flex gap-2">
          <Input placeholder="Search suppliers…" value={q} onChange={(e)=>setQ(e.target.value)} className="w-64" data-testid="supplier-search"/>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-supplier-btn"><Plus className="w-4 h-4 mr-1"/>New supplier</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Add supplier</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Name *</Label><Input value={f.name} onChange={(e)=>setF({...f, name:e.target.value})} data-testid="supplier-name"/></div>
                <div><Label>Category / service area</Label><Input value={f.category} onChange={(e)=>setF({...f, category:e.target.value, service_area:e.target.value})}/></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Phone</Label><Input value={f.phone} onChange={(e)=>setF({...f, phone:e.target.value})}/></div>
                  <div><Label>Email</Label><Input value={f.email} onChange={(e)=>setF({...f, email:e.target.value})}/></div>
                </div>
                <div><Label>Notes</Label><Input value={f.notes} onChange={(e)=>setF({...f, notes:e.target.value})}/></div>
              </div>
              <DialogFooter><Button onClick={save} disabled={!f.name} data-testid="supplier-save">Save</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <Card className="border-slate-200"><CardContent className="p-4">
        <div className="border border-slate-200 rounded-md overflow-hidden">
          <Table className="dense-table">
            <TableHeader><TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Service area</TableHead>
              <TableHead>Contact</TableHead>
              <TableHead>Trigger</TableHead>
              <TableHead>Preferred</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((s)=>(
                <TableRow key={s.id} className="cursor-pointer hover:bg-slate-100" onClick={()=>nav(`/suppliers/${s.id}`)} data-testid={`supplier-row-${s.id}`}>
                  <TableCell className="font-medium">{s.name}</TableCell>
                  <TableCell className="text-slate-600 text-sm">{s.service_area||s.category||"—"}</TableCell>
                  <TableCell className="text-xs"><div>{s.phone||"—"}</div><div className="text-slate-500">{s.email||""}</div></TableCell>
                  <TableCell className="text-xs text-slate-600 max-w-xs">{s.frequency_trigger||"—"}</TableCell>
                  <TableCell>{s.preferred ? <Badge className="bg-amber-100 text-amber-800 border-0"><Star className="w-3 h-3 mr-1"/>Preferred</Badge> : ""}</TableCell>
                </TableRow>
              ))}
              {rows.length===0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-8">No suppliers.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </CardContent></Card>
    </div>
  );
}
